
import ApiService from './ApiService';

const saveStepInformation = (context, step) => {
    const urlRef = context.URLRef;
    const modo = context.modo;
    const combo = context.combo;
    const idCampania = context.isBonusSale || context.combo === context.comboBonificado ? context.campaniaBonificada : context.campaniaId;
    const nombrePlan = context.planCampania?.planes[0]?.nombre ?? null;
    const esFamiliar = context.planCampania?.planes[0]?.esFamiliar;
    const canalVenta = context.canalDeVenta;
    const formaContacto = context.formaDeContacto;
    const planId = context.planCampania?.planes[0]?.id;
    const reportAddress = context.planCampania?.planes[0]?.informaDomicilio;
    const residence = context.datosPersonales?.residencia;
    const familiaProductoId = context.planCampania?.planes[0]?.detalles[0]?.familiaProducto?.id;

    const payload = {
        step: step,
        url_ref: urlRef,
        modo: modo,
        combo: combo,
        sale_channel: canalVenta,
        contact_form: formaContacto,
        plan_id: planId,
        is_family: esFamiliar,
        plan_name: nombrePlan,
        correlation_id : context.correlationId,
        campaign_id: idCampania,
        report_address: reportAddress,
        residence: residence,
        product_family_id: familiaProductoId
    };
    const { REACT_APP_APIPAYWALL } = process.env;
    return ApiService.post(`${REACT_APP_APIPAYWALL}Notification/SaveStepInformation`, payload);
};

export default { saveStepInformation };